/**
 * PURPOSE: Permitir agregar columnas repetibles desde el catálogo válido del deporte.
 * RESPONSIBILITIES: Mostrar combinaciones permitidas y crear el siguiente slot disponible.
 * COLLABORATORS: UniformMatrix.jsx y uniformMatrix.constants.js.
 * ROUTE: winscore/src/components/UniformMatrix/UniformMatrixColumnPicker.jsx
 */
import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";

export function UniformMatrixColumnPicker({ catalog, onAdd }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative">
      <button type="button" onClick={() => setOpen((value) => !value)} className="inline-flex items-center gap-2 rounded-xl border border-indigo-200 bg-indigo-50 px-3 py-2 text-sm font-bold text-indigo-700 hover:bg-indigo-100"><FaPlus /> Agregar columna</button>
      {open ? (
        <div className="absolute right-0 z-30 mt-2 w-56 rounded-xl border border-gray-200 bg-white p-2 shadow-xl">
          {catalog.map((item) => (
            <button key={`${item.type}-${item.tone}`} type="button" onClick={() => { onAdd(item); setOpen(false); }} className="block w-full rounded-lg px-3 py-2 text-left text-sm font-semibold text-gray-700 hover:bg-gray-100">{item.label}</button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
